export const workspace = {
  routes: [
    {
      path: "/workspace/library/datasubject-right",
      component: () => import("../workspace-library-datasubject-right-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/datasubject-right",
      component: () => import("../management-library-datasubject-right-view"),
    },
  ],
};
